import { CharacterIcon } from './CharacterIcon';

export enum CharacterRole {
  VICTIM = 'VICTIM',
  SUPPORTER = 'SUPPORTER',
  MEDIATOR = 'MEDIATOR',
  APPROACHER = 'APPROACHER',
  SIDE_ATTACKER = 'SIDE_ATTACKER',
}

export enum CharacterOrientation {
  ORIGINAL = 'ORIGINAL',
  FLIPPED = 'FLIPPED',
}

export type UninitializedCharacter = Partial<Character> &
  Pick<Character, 'name' | 'icon' | 'statement' | 'role'>;

export interface Character {
  id: string;
  name: string;
  icon: CharacterIcon;
  statement: string;
  role: CharacterRole[];
  assetPath: string;
  position: {
    x: number;
    y: number;
  };
  width: number;
  height: number;
  ratio: number;
  orientation: CharacterOrientation;
}
